<template>
    <Card :data-testid="`testimonial-card-${index}`">
        <template #content>
            <PrismicRichText :field="testimonial" class="testimonial-card__testimonial" :data-testid="`testimonial-card-${index}-testimonial`" />
        </template>
        <template #footer>
            <div class="testimonial-card__author">
                <MktCardHandAdaptive v-if="image" brand-theme class="testimonial-card__author-image-wrapper">
                    <PrismicImage v-if="image" :field="image" width="500" :data-testid="`testimonial-card-${index}-image`" />
                </MktCardHandAdaptive>
                <div>
                    <div class="testimonial-card__author-name" :data-testid="`testimonial-card-${index}-author-name`">{{ name }}</div>
                    <div class="testimonial-card__author-job-title" :data-testid="`testimonial-card-${index}-author-job`">{{ jobTitle }}</div>
                </div>
            </div>
        </template>
    </Card>
</template>

<script setup lang="ts">
    import type {ImageField, RichTextField} from '@prismicio/types';
    import {PrismicImage, PrismicRichText} from '@prismicio/vue';
    import {MktCardHandAdaptive} from '#components';
    import Card from './Card.vue';

    defineProps<{
        index: number;
        testimonial?: RichTextField;
        name?: string;
        jobTitle?: string;
        image?: ImageField;
    }>();
</script>

<style lang="scss">
    @use '@malt/joy-entrypoint/src/sass/base/2_mixins/text' as text;
    @use '@malt/joy-entrypoint/src/sass/base/2_mixins/media-queries/media-queries' as mq;

    .testimonial-card {
        &__testimonial {
            :first-child {
                &:before {
                    content: '“';
                }
            }
            :last-child {
                &:after {
                    content: '”';
                }
            }
        }

        &__author {
            display: flex;
            flex-direction: column;
            margin-top: var(--joy-core-spacing-6);
            width: 100%;

            &-image-wrapper {
                $image-width: 53px;
                width: $image-width;
                min-width: $image-width;
                margin: 0 auto var(--joy-core-spacing-6) auto;
            }
            &-name {
                font-family: var(--joy-font-family-title);
            }
            &-job-title {
                @include text.getFontBySize(primary-400);
                font-weight: 400;
            }

            @include mq.screen_xs(min) {
                flex-direction: row;

                &-image-wrapper {
                    margin: 0 var(--joy-core-spacing-6) 0 0;
                }
            }
        }
    }
</style>
